import { AJOUTE_OFFRE, SUPRIMER_OFFRE } from '../types/typeOffre';

export const ajouteOffre = (offre) => {
    return {
        type: AJOUTE_OFFRE,
        payload: offre
    }
}

export const suprimerOffre = () => {
    return {
        type: SUPRIMER_OFFRE,
        payload: []
    }
}